<gstar-security-types-grid
  [source]="securityTypes()"
  [query]="query"
  (queryChange)="queryUpdate($event)"
  (create)="create($event)"
  (update)="update($event)" />
